import React, { forwardRef } from "react";
import styled from "styled-components";

const Input = forwardRef(
  ({ label, icon, style, className, value, onChange, placeholder, "data-testid": dataTestId }, ref) => {
    // Handler for clear button
    const handleClear = (e) => {
      if (onChange) {
        onChange({
          ...e,
          target: { ...e.target, value: "" },
        });
      }
    };
    return (
      <StyledWrapper className={className}>
        <div style={style} className="inputContainer">
          <input
            className="inputField"
            data-testid={dataTestId || "input-field"}
            ref={ref}
            required="required"
            id="inputField"
            placeholder={placeholder || label}
            type="text"
            value={value}
            onChange={onChange}
          />
          <label className="label" htmlFor="inputField">
            {label}
          </label>
          <span className="icon">{icon}</span>
          {value && value.length > 0 && (
            <button
              type="button"
              className="clearButton"
              aria-label="Clear input"
              onClick={handleClear}
            >
              &#10005;
            </button>
          )}
        </div>
      </StyledWrapper>
    );
  }
);

const StyledWrapper = styled.div`
  .inputContainer {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 10px;
    background-color: transparent !important;
  }

  #inputField {
    border: 2px solid var(--secondary-color);
    background-color: transparent;
    border-radius: 10px;
    padding: 12px 15px 12px 40px; /* left padding for icon */
    color: var(--text-color, white);
    font-weight: 500;
    outline: none;
    caret-color: var(--secondary-color);
    transition-duration: 0.3s;
    font-family: Whitney, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
  }

  .icon {
    position: absolute;
    fill: var(--secondary-color);
    width: 18px;
    height: 18px;
    top: 50%;
    left: 12px;
    transform: translateY(-50%);
    opacity: 1;
    pointer-events: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .clearButton {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: var(--secondary-color);
    font-size: 18px;
    cursor: pointer;
    opacity: 0.7;
    padding: 0;
    z-index: 2;
    transition: opacity 0.2s;
  }
  .clearButton:hover {
    opacity: 1;
  }

  .label {
    position: absolute;
    top: -25px;
    left: 5px;
    color: var(--text-color, white);
    font-size: 14px;
    font-weight: 400;
    overflow: hidden;
    transition: 0.2s linear;
    opacity: 0;
  }

  #inputField:focus ~ .label,
  #inputField:valid ~ .label {
    transform: translateX(20px);
    opacity: 1;
    background-color: transparent !important;
  }
  #inputField:focus,
  #inputField:valid {
    background-color: transparent !important;
    transition-duration: 0.3s;
  }

  /* Override autofill styles */
  #inputField:-webkit-autofill,
  #inputField:-webkit-autofill:hover,
  #inputField:-webkit-autofill:focus,
  #inputField:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 1000px transparent inset !important;
    -webkit-text-fill-color: var(--text-color, white) !important;
    background-color: transparent !important;
    transition: background-color 5000s ease-in-out 0s;
  }

  /* For Firefox */
  #inputField:-moz-autofill {
    background-color: transparent !important;
    box-shadow: 0 0 0 1000px transparent inset !important;
    color: var(--text-color, white) !important;
  }
`;

export default Input;
